// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_3L-Pzs4WD7927tHtMxVomM","wrap":"_2pGwMQ8cjz0cRXvGUKJYrO","preloader":"_2ZX7wjsZsnhb2XqgQDmet5","label":"_10H04Lkh4ToxSXLA7MhWpA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Logout/Logout.scss
// module id = 2598
// module chunks = 0